import AddCircleIcon from '@mui/icons-material/AddCircle';
import { ToggleButton, ToggleButtonProps } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { useTiptapEditor } from 'ra-input-rich-text';
import { useState } from 'react';
import { Button, useTranslate } from 'react-admin';

interface InsertMergeFieldButtonProps extends Omit<ToggleButtonProps, 'value'> {
  fields: Array<{ value: string, caption: string }>,
}

const InsertMergeFieldButton = (props: InsertMergeFieldButtonProps) => {
  const translate = useTranslate();
  const editor = useTiptapEditor();
  const [showDialog, setShowDialog] = useState(false);
  const [checked, setChecked] = useState<string>("");

  const addImage = () => {
    setShowDialog(true);
  }

  const handleSelectClick = () => {
    if (checked) {
      editor.chain().focus().insertContent(checked).run();
    }
    setShowDialog(false)
  }

  const handleCloseClick = () => {
    setShowDialog(false)
  }

  return editor ? (
    <>
      <ToggleButton
        size={props.size}
        aria-label={"merge-field"}
        title={"merge-field"}
        {...props}
        disabled={!editor?.isEditable}
        value="image"
        onClick={addImage}
      >
        <AddCircleIcon fontSize="inherit" />
      </ToggleButton>
      <Dialog open={showDialog} scroll={'paper'}>
        <DialogTitle id="scroll-dialog-title">Merge Fields</DialogTitle>
        <DialogContent dividers={true}>
          <List>
            {props.fields.map(({ value, caption }) => {
              const labelId = `checkbox-list-label-${value}`;

              return (
                <ListItem
                  key={value}
                  disablePadding
                >
                  <ListItemButton role={undefined} onClick={() => setChecked(value)} dense>
                    <ListItemText id={labelId} primary={`${caption}`} />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSelectClick} label={translate("ra.action.confirm")} disabled={"" === checked} />
          <Button onClick={handleCloseClick} label={translate("ra.action.close")} />
        </DialogActions>
      </Dialog>
    </>
  ) : null;
};

export default InsertMergeFieldButton;
